import PropTypes from 'prop-types';

export const DataTestAttrsType = PropTypes.shape({
  component: PropTypes.string,
  element: PropTypes.string,
  key: PropTypes.string,
  index: PropTypes.string,
});

export default DataTestAttrsType;
